module.exports = __webpack_public_path__ + "html/wistia-player_507bd1b56b94946825e085bf0256658b.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wistia-player.html
// module id = ze4q
// module chunks = 23